/**
 * 401处理
 * 1、当设置了special时，匹配alias获取当前站点的定制，优先级最高
 * 2、当匹配不到当前站点的定制跳转时，执行后续操作
 * --1、当存在portalCode时,为门户应用,前往/[portalCode]/user-center/user/login
 * --2、当不存在portalCode时,前往站点loginUrl
 */

import { message } from 'antd';
import { getMapLoginUrl } from "./getMapLoginUrl";
/**
 * 根据storageKey获取站点信息
 * 获取站点信息
 */
var getSiteStorage = function getSiteStorage(storageKey) {
  return JSON.parse(localStorage.getItem(storageKey) || '{}');
};
var shouldLogin = function shouldLogin(params) {
  var _ref = params || {},
    alias = _ref.alias,
    special = _ref.special,
    portalCode = _ref.portalCode,
    storageKey = _ref.storageKey,
    identity = _ref.identity;
  /** 当存在定制时 查找当前站点的定制url */
  var currentSpecial = special === null || special === void 0 ? void 0 : special.find(function (item) {
    return item.alias === alias;
  });
  if (currentSpecial) {
    location.href = currentSpecial.url;
  } else {
    /**
     * 不存在定制url时,判断portalCode是否存在
     */
    var siteStorage = getSiteStorage(storageKey);
    if (siteStorage !== null && siteStorage !== void 0 && siteStorage.siteData) {
      if (portalCode) {
        /**--portalCode存在时，为门户应用，前往登录路由 */
        location.replace("/".concat(portalCode, "/user-center/user/login"));
      } else {
        /**--portalCode不存在时，为工作台或者独立部署，前往loginUrl */
        var loginUrl = getMapLoginUrl({
          type: 'storage',
          key: storageKey,
          identity: identity
        });
        if (loginUrl) {
          location.replace("".concat(loginUrl));
        } else {
          message.error('登录地址获取失败！');
        }
      }
    } else {}
  }
};
export default shouldLogin;